import { useEffect } from 'react';
import { motion } from 'motion/react';
import { BookOpen } from 'lucide-react';

export default function Blog() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 pt-32 pb-20">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="w-20 h-20 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-8">
            <BookOpen className="text-primary" size={36} />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Blog
          </h1>
          <p className="text-xl text-slate-600">
            Industry insights, case studies, and technical guides — coming soon.
          </p>
        </motion.div>
      </div>
    </div>
  );
}
